import React, { useState } from 'react'
import { Form, Button } from 'react-bootstrap'
import { fetchcallaction } from '../redux/Calls/CallAction'
import { connect, useDispatch, useSelector } from 'react-redux'
function CallDialPad(props) {
  let statevalue = useSelector((state) => state)
  const [dial, setDial] = useState('')

  const setDialFun = (number) => {
    const num = dial + '' + number
    setDial(num)
  }
  const clearText = () => {
    var text = dial.slice(0, -1)
    setDial(text)
  }

  const closeDialpad = (e) => {
    if (props.loaddialpad) {
      props.callAction('on_call')
    } else {
      props.dialpad(e)
    }
  }
  const sendnumber = (e) => {
    if (props.othersdialpad) {
      props.dialpadnumber_transfer(e)
    } else {
      props.dialpadnumbers(e)
      props.callAction('on_log')
    }
  }

  return (
    <div className="dialpad">
      <div className="dialpad_sub_container">
        {props.calllogdialpad && (
          <div className="contact_head Dialpad_head">
            <h3>Dial Pad</h3>
            <div>
              <span
                className="material-icons"
                onClick={() => closeDialpad(true)}
              >
                close
              </span>
            </div>
          </div>
        )}
        <div className="numberpad">
          
          <Form.Control
            type="text"
            value={dial}
            className="pad"
            onChange={(e) => setDial(e.target.value)}
          />
          <span
            className="material-icons icon-cls"
            style={{ marginLeft: 30 }}
            onClick={() => clearText()}
          >
            backspace
          </span>
        </div>
        <div className="dialnumber">
          <div>
            <span onClick={() => setDialFun(1)}>1</span>
            <span onClick={() => setDialFun(2)}>2</span>
            <span onClick={() => setDialFun(3)}>3</span>
          </div>
          <div>
            <span onClick={() => setDialFun(4)}>4</span>
            <span onClick={() => setDialFun(5)}>5</span>
            <span onClick={() => setDialFun(6)}>6</span>
          </div>
          <div>
            <span onClick={() => setDialFun(7)}>7</span>
            <span onClick={() => setDialFun(8)}>8</span>
            <span onClick={() => setDialFun(9)}>9</span>
          </div>
          <div>
            <span onClick={() => setDialFun('*')}>*</span>
            <span onClick={() => setDialFun(0)}>0</span>
            <span onClick={() => setDialFun('#')}>#</span>
          </div>
        </div>
        <div>
          {(statevalue.background.oncall === false || props.othersdialpad === true) && (
            <div>
              <Button
                className={ "callnow " }
                onClick={() => {
                  sendnumber(dial)
                }}
              >
                Call Now
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
const mapDispatchToProps = (dispatch) => {
  return {
    callAction: (type) => dispatch(fetchcallaction(type)),
  }
}
export default connect(null, mapDispatchToProps)(CallDialPad)
